export const appHead = {"link":[{"rel":"icon","type":"image/png","sizes":"16x16","href":"https://res.cloudinary.com/onderwijsin/image/upload/w_16,h_16,c_scale/v1683720669/brand/favicon_onderwijsloket_isiqbk.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"https://res.cloudinary.com/onderwijsin/image/upload/w_32,h_32,c_scale/v1683720669/brand/favicon_onderwijsloket_isiqbk.png"},{"rel":"icon","type":"image/png","sizes":"48x48","href":"https://res.cloudinary.com/onderwijsin/image/upload/w_48,h_48,c_scale/v1683720669/brand/favicon_onderwijsloket_isiqbk.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"https://res.cloudinary.com/onderwijsin/image/upload/w_96,h_96,c_scale/v1683720669/brand/favicon_onderwijsloket_isiqbk.png"},{"rel":"icon","type":"image/png","sizes":"144x144","href":"https://res.cloudinary.com/onderwijsin/image/upload/w_144,h_144,c_scale/v1683720669/brand/favicon_onderwijsloket_isiqbk.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"https://res.cloudinary.com/onderwijsin/image/upload/w_192,h_192,c_scale/v1683720669/brand/favicon_onderwijsloket_isiqbk.png"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=5.0, viewport-fit=cover"},{"name":"format-detection","content":"telephone=no"},{"property":"og:type","content":"website"}],"style":[],"script":[],"noscript":[{"children":"Je hebt Javascript nodig om deze website te kunnen gebruiken. Pas je browserinstellingen in om verder te gaan!"}],"htmlAttrs":{}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"trailingSlash":"append","componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"